var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 24,
    viewBox: "0 0 28 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.4998 12.0002C27.4998 12.4477 27.3221 12.877 27.0056 13.1934C26.6891 13.5099 26.2599 13.6877 25.8123 13.6877L6.26097 13.6877L13.5071 20.9304C13.664 21.0873 13.7884 21.2736 13.8734 21.4786C13.9583 21.6836 14.002 21.9033 14.002 22.1252C14.002 22.3471 13.9583 22.5668 13.8734 22.7718C13.7884 22.9768 13.664 23.163 13.5071 23.3199C13.3502 23.4768 13.1639 23.6013 12.9589 23.6862C12.7539 23.7711 12.5342 23.8148 12.3123 23.8148C12.0905 23.8148 11.8707 23.7711 11.6657 23.6862C11.4608 23.6013 11.2745 23.4768 11.1176 23.3199L0.992593 13.1949C0.835442 13.0382 0.710759 12.852 0.625687 12.6469C0.540616 12.4419 0.496826 12.2221 0.496826 12.0002C0.496826 11.7782 0.540616 11.5584 0.625687 11.3534C0.710759 11.1484 0.835442 10.9622 0.992593 10.8054L11.1176 0.680429C11.4345 0.363562 11.8642 0.185547 12.3123 0.185547C12.7605 0.185547 13.1902 0.363562 13.5071 0.680429C13.824 0.997296 14.002 1.42706 14.002 1.87518C14.002 2.3233 13.824 2.75306 13.5071 3.06993L6.26097 10.3127L25.8123 10.3127C26.2599 10.3127 26.6891 10.4905 27.0056 10.8069C27.3221 11.1234 27.4998 11.5526 27.4998 12.0002Z",
    fill: "#568EFC"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/Arrow.7248e757.svg";
export { ForwardRef as ReactComponent };